import { KalturaMeta, KalturaMetaListResponse, MetaListAction } from '@kaltura-ott/ott-client-types/api/types';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { kalturaClient } from './kaltura-clent';
import { BASIC_METAS } from './utils/constants';

export const getBasicMetas = (): Observable<KalturaMeta[]> => {
  const action = new MetaListAction();
  const client = kalturaClient();
  return client.request(action).pipe(
    map((metas: KalturaMetaListResponse) => {
      return metas.objects.filter(
        (meta) => BASIC_METAS.map((meta) => meta.toLowerCase()).indexOf(meta.systemName.toLowerCase()) != -1,
      );
    }),
    catchError((err) => {
      return of(err);
    }),
  );
};

/**
 * returns list of default meta Ids
 */
export const defaultMetaIDs = (): Observable<string[]> => {
  return getBasicMetas().pipe(map((metas) => metas.map((m) => m.id)));
};
